import React, { useState } from 'react';

import { Box, Button } from '@mui/material';

import OhsModuleHeader from 'global-components/register/OhsModuleHeader';

import CategoryCusvalInvalid from './CategoryCusvalInvalid';
import CategoryCusvalCategoryChange from './CategoryCusvalCategoryChange';

function CategoryCusvalUITestMain() {
  const [activeTab, setActiveTab] = useState(1);

  const tabs = [
    {
      id: 1,
      name: 'Category Change',
      component: <CategoryCusvalCategoryChange />,
    },
    {
      id: 2,
      name: 'Invalid Cusvals',
      component: <CategoryCusvalInvalid />,
    },
  ];

  return (
    <Box>
      <OhsModuleHeader title="Cusval (Dynamic)" as="h3" />

      {/* Header */}
      <Box width="100%" display="flex" mb={4}>
        {tabs.map((tab) => {
          return (
            <Box mr={1}>
              <Button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                variant={activeTab === tab.id ? 'contained' : 'outlined'}
              >
                {tab.name}
              </Button>
            </Box>
          );
        })}
      </Box>

      {/* Content */}
      <Box width="100%">{tabs.find((tab) => tab.id === activeTab)?.component}</Box>
    </Box>
  );
}

export default CategoryCusvalUITestMain;
